// extracted by mini-css-extract-plugin
module.exports = {"title":"SEO-module--title--iG7re"};